import React, {useEffect, useState} from 'react';
import {SiteInfo} from "../../../../interface/model/site";
import {constructVisitorInfo, VisitorApplicationInfo, VisitorInfo} from "../../../../interface/model/visitor";
import {EquipmentInfo, StuffInfo} from "../../../../interface/model/visitorExtends";
import {VisitDateComponent} from "../../../../component/visit-application/visit-date";
import VisitTimeComponent from "../../../../component/visit-application/visit-time";
import FindSiteComponent from "../../../../component/visit-application/find-site";
import FindHostComponent from "../../../../component/visit-application/find-host";
import VisitorInfoComponent from "../../../../component/visit-application/visitor-Info";
import {isValidPhoneNumber, isValidBirthDay, isValidCarNumber} from '../../../../component/visit-application/visit-valid';
import Api from "../../../../interface/api/visit";
import {BlueButton} from "../../../../component/button";

interface localVisitorInfo {
    visitorInfo:VisitorInfo
    equipmentInfo?:EquipmentInfo,
    stuffInfos?:Array<StuffInfo>
}

export default function VisitNormal() {

    const [ siteInfo, setSiteInfo ] = useState<SiteInfo>();

    const [ locationArea, setLocationArea ] = useState({area2_state : false, area3_state : false, area4_state : false, area5_state : false});
    const [ addedVisitLocations, setAddedVisitLocations ] = useState({area2_location : '', area3_location : '', area4_location : '', area5_location : ''});
    const [ visitorApplicationInfo, setVisitorApplicationInfo ] = useState<VisitorApplicationInfo>();
    const [ certificateFlag, setCertificateFlag ] = useState(true);

    const [ visitorInfos, setVisitorInfos ] = useState<Array<localVisitorInfo>>([{
        visitorInfo:{...constructVisitorInfo, standardFlag:false}
    }]);

    function submit() {
        let valid = true;
        let completeLocationStr;

        // 1) 방문자 입력 검증
        for (const { visitorInfo } of visitorInfos) {
            const { birthDay, phone, carFlag, car } = visitorInfo;

            if (!isValidBirthDay(birthDay)) {
                alert(`생년월일을 확인해주세요.\r\n ex) 19910101`);
                valid = false;
            }
            if (!isValidPhoneNumber(phone)) {
                alert(`연락처를 확인해주세요.\r\n ex) 01011112222`);
                valid = false;
            }
            if (carFlag == 'true' && !isValidCarNumber(car)) {
                alert(`차량번호를 확인해주세요.`);
                valid = false;
            }
        }

        // 2) 방문 위치 처리
        const visitLoc = visitorApplicationInfo.visitLocation;
        if (visitLoc) {
            const [p0 = '', p1 = ''] = visitLoc.split(',');
            const defaultLocationStr = `${p0},${p1}`;
            const thereDepthsStr = visitLoc.substring(defaultLocationStr.length + 1);

            const isSLD = siteInfo.name === '솔브레인에스엘디';
            const appendOffset = defaultLocationStr.length + (isSLD ? 6 : 1);

            // 첫 위치
            const head = thereDepthsStr.split('/')[0];
            let first = isSLD ? head.substring(5).split('/')[0] : head;

            // 선택 추가 위치들 수집
            const getTail = (enabled: boolean, value?: string) =>
                enabled && value ? value.substring(appendOffset) : '';

            const parts: string[] = [first];

            const a2 = getTail(locationArea.area2_state, addedVisitLocations.area2_location);
            if (a2) parts.push(a2);

            const a3 = getTail(locationArea.area3_state, addedVisitLocations.area3_location);
            if (a3) parts.push(a3);

            const a4 = getTail(locationArea.area4_state, addedVisitLocations.area4_location);
            if (a4) parts.push(a4);

            const a5 = getTail(locationArea.area5_state, addedVisitLocations.area5_location);
            if (a5) parts.push(a5);

            // 중복 체크
            const hasDup = new Set(parts).size !== parts.length;
            if (hasDup) {
                valid = false;
                alert('중복된 방문위치가 존재합니다.');
            } else {
                const joined = parts.join('/'); // 기존 '§'로 붙인 뒤 replace → 바로 join('/')로 동일 효과
                completeLocationStr = isSLD
                    ? `${defaultLocationStr},${thereDepthsStr.substring(0, 5)}${joined}`
                    : `${defaultLocationStr},${joined}`;
            }
        } else {
            alert('방문위치를 선택해주세요.');
            valid = false;
        }

        // 3) 최종 저장
        if (valid && completeLocationStr) {
            Api.createVisitInfo(
                { ...visitorApplicationInfo, visitLocation: completeLocationStr, certificateFlag },
                visitorInfos
            ).then(() => {
                alert('정상적으로 등록되었습니다.');
            });
        }
    }

    function checkTime() {
        let nDate = new Date();
        let today = nDate.getFullYear()+"-"+((nDate.getMonth()+1)<10 ? "0"+(nDate.getMonth()+1) : (nDate.getMonth()+1))+"-"+(nDate.getDate()<10 ? "0"+nDate.getDate() : nDate.getDate());
        let nTime = nDate.getHours();
        let startDate = ( visitorApplicationInfo !== undefined && visitorApplicationInfo.startDate !== undefined ) ? visitorApplicationInfo.startDate : ''

        if( startDate == today ) {
            return nTime;
        }
        // return 9;
        // 2022-08-30 > 솔브레인 김영찬 매니저 요청으로 업데이트
        return 0;
    }

    function addLocation() {
        if(locationArea.area2_state === false) {
            setLocationArea({...locationArea, area2_state : true});
        } else if(locationArea.area3_state === false) {
            setLocationArea({...locationArea, area3_state : true});
        } else if(locationArea.area4_state === false) {
            setLocationArea({...locationArea, area4_state : true});
        } else if(locationArea.area5_state === false) {
            setLocationArea({...locationArea, area5_state : true});
        } else {
            alert('방문위치는 최대 5개 등록 가능합니다.');
        }
    }

    function delLocation(idx) {
        switch (idx) {
            case 2 :
                setLocationArea({...locationArea, area2_state : false});
                setAddedVisitLocations({...addedVisitLocations, area2_location: ''});
                break;
            case 3 :
                setLocationArea({...locationArea, area3_state : false});
                setAddedVisitLocations({...addedVisitLocations, area3_location: ''});
                break;
            case 4 :
                setLocationArea({...locationArea, area4_state : false});
                setAddedVisitLocations({...addedVisitLocations, area4_location: ''});
                break;
            case 5 :
                setLocationArea({...locationArea, area5_state : false});
                setAddedVisitLocations({...addedVisitLocations, area5_location: ''});
                break;
        }
    }

    useEffect(() => {
        setSiteInfo(JSON.parse(localStorage.getItem('siteInfo')));
    }, [])

    return (
        <>
            <div className="nv_contents">
                <div className="nv_table_tit regist_tit">
                    <h4>방문 정보</h4>
                </div>
                
                <div className="nv_table_box">
                    <dl className="nv_dl_table nv_approve_table">
                        <dt>방문기간</dt>
                        <dd className="nv_dd_full nv_date under_max_200">
                            <VisitDateComponent selectedHandler={(date) =>
                                    setVisitorApplicationInfo({...visitorApplicationInfo, startDate:date})} />
                        </dd>
                        <dt className="nv_mobile_dd">방문시간</dt>
                        <dd className="nv_dd_full nv_date adminVersion nv_mobile_dd">
                            <VisitTimeComponent
                                placeholder={'입문 시간 선택'}
                                start={checkTime()}
                                // end={18}
                                // 2022-08-30 > 솔브레인 김영찬 매니저 요청으로 업데이트
                                end={22}
                                onChangeHandler={(selectedTime) =>
                                    setVisitorApplicationInfo({...visitorApplicationInfo, startTime:selectedTime })
                                }
                            />
                            <VisitTimeComponent
                                placeholder={'출문 시간 선택'}
                                start={visitorApplicationInfo!==undefined ? visitorApplicationInfo.startTime+1 : 0}
                                // end={18}
                                end={23}
                                onChangeHandler={(selectedTime) =>
                                    setVisitorApplicationInfo({...visitorApplicationInfo, endTime:selectedTime })
                                }
                            />
                        </dd>
                        <dt className="nv_mobile_dd">방문위치</dt>
                        <dd className="nv_dd_full nv_date nv_double_select adminVersion nv_mobile_dd addedVisitLocation">
                            <FindSiteComponent siteInfo={JSON.parse(localStorage.getItem('siteInfo'))} selectedHandler={
                                (visitLocation) =>
                                    setVisitorApplicationInfo({...visitorApplicationInfo, visitLocation:visitLocation})
                            }/>
                            <div>
                                <BlueButton
                                    type = { 'button' }
                                    onClickHandler = { addLocation }
                                    innerHTML = { '추가' }
                                />
                            </div>
                        </dd>
                        {
                            locationArea.area2_state &&
                            <div>
                                <dt className="nv_mobile_dd">방문위치</dt>
                                <dd className="nv_dd_full nv_date nv_double_select adminVersion nv_mobile_dd addedVisitLocation">
                                    <FindSiteComponent
                                        siteInfo={JSON.parse(localStorage.getItem('siteInfo'))}
                                        selectedHandler = { (visitLocation) => setAddedVisitLocations({...addedVisitLocations, area2_location: visitLocation}) }
                                     />
                                    <button
                                        type = "button"
                                        className = "nv_button_red minus"
                                        onClick = { () => delLocation(2)} >
                                        삭제
                                    </button>
                                </dd>
                            </div>
                        }
                        {
                            locationArea.area3_state &&
                            <div>
                                <dt className="nv_mobile_dd">방문위치</dt>
                                <dd className="nv_dd_full nv_date nv_double_select adminVersion nv_mobile_dd addedVisitLocation">
                                    <FindSiteComponent
                                        siteInfo={JSON.parse(localStorage.getItem('siteInfo'))}
                                        selectedHandler = { (visitLocation) => setAddedVisitLocations({...addedVisitLocations, area3_location: visitLocation}) }
                                    />
                                    <div>
                                        <button
                                            type = "button"
                                            className = "nv_button_red minus"
                                            onClick = { () => delLocation(3)} >
                                            삭제
                                        </button>
                                    </div>
                                </dd>
                            </div>
                        }
                        {
                            locationArea.area4_state &&
                            <div>
                                <dt className="nv_mobile_dd">방문위치</dt>
                                <dd className="nv_dd_full nv_date nv_double_select adminVersion nv_mobile_dd addedVisitLocation">
                                    <FindSiteComponent
                                        siteInfo={JSON.parse(localStorage.getItem('siteInfo'))}
                                        selectedHandler = { (visitLocation) => setAddedVisitLocations({...addedVisitLocations, area4_location: visitLocation}) }
                                    />
                                    <div>
                                        <button
                                            type = "button"
                                            className = "nv_button_red minus"
                                            onClick = { () => delLocation(4)} >
                                            삭제
                                        </button>
                                    </div>
                                </dd>
                            </div>
                        }
                        {
                            locationArea.area5_state &&
                            <div>
                                <dt className="nv_mobile_dd">방문위치</dt>
                                <dd className="nv_dd_full nv_date nv_double_select adminVersion nv_mobile_dd addedVisitLocation">
                                    <FindSiteComponent
                                        siteInfo={JSON.parse(localStorage.getItem('siteInfo'))}
                                        selectedHandler = { (visitLocation) => setAddedVisitLocations({...addedVisitLocations, area5_location: visitLocation}) }
                                    />
                                    <div>
                                        <button
                                            type = "button"
                                            className = "nv_button_red minus"
                                            onClick = { () => delLocation(5)} >
                                            삭제
                                        </button>
                                    </div>
                                </dd>
                            </div>
                        }
                        <dt className="nv_mobile_dd">교육 대상여부</dt>
                        <dd className="nv_dd_full nv_mobile_dd">
                            <div className="nv_select_box selectCertificate">
                                <input type="radio" name="certificate_check" id="c1_y"
                                       value="true"
                                       onClick={() => setCertificateFlag(true)}
                                       checked={certificateFlag == true ? true : false}/>
                                <label htmlFor="c1_y">대상</label>
                                <input type="radio" name="certificate_check" id="c1_n"
                                       value="false"
                                       onClick={() => setCertificateFlag(false)}
                                       checked={certificateFlag == false ? true : false}/>
                                <label htmlFor="c1_n">비대상</label>
                            </div>
                        </dd>
                        <dt className="nv_mobile_dd">방문목적</dt>
                        <dd className="nv_dd_full nv_mobile_dd">
                            <div className="nv_select_box adminVersion under_max_200" id="visitorPurpose" style={{width: '100%'}}>
                                <select name="visitPurpose" className="nv_select_box"
                                        onChange={
                                            (e) =>
                                                setVisitorApplicationInfo({...visitorApplicationInfo, visitPurpose:e.target.value})
                                        }
                                >
                                    <option selected={true} disabled={true}>선택</option>
                                    {
                                        certificateFlag ?
                                            JSON.parse(localStorage.getItem('siteInfo')).siteVisitPurposeInfos !== undefined &&
                                                JSON.parse(localStorage.getItem('siteInfo')).siteVisitPurposeInfos.map((row, index) => (
                                                <option key={`siteVisitPurposeInfosKey-${index}`} value={row.name}>{row.name}</option>
                                            )) :
                                            <>
                                                <option value="면접">면접</option>
                                                <option value="택배/우편">택배/우편</option>
                                                <option value="건강검진">건강검진</option>
                                                <option value="작업환경측정">작업환경측정</option>
                                                <option value="관공서">관공서</option>
                                                <option value="회의">회의</option>
                                                <option value="단순납품">단순납품</option>
                                                <option value="기타">기타</option>
                                            </>
                                    }
                                </select>
                                <input
                                    type="text"
                                    className="nv_input input_car"
                                    name="visitPurposeDetail"
                                    id="visitPurposeDetail"
                                    onChange={
                                        (e) =>
                                            setVisitorApplicationInfo({...visitorApplicationInfo, visitPurposeDetail:e.target.value})
                                    }
                                    placeholder="방문상세목적"/>
                            </div>
                        </dd>
                    </dl>
                </div>
                <div className="nv_table_tit regist_tit">
                    <h4>접견인정보</h4>
                </div>
                <div className="nv_table_box">
                    <dl className="nv_dl_table">
                        <dt>접견인</dt>
                        <dd className="nv_dd_full">
                            <div className="adminVersion under_max_200">
                                <FindHostComponent onClickHandler={
                                    (hostInfo) =>
                                        setVisitorApplicationInfo({...visitorApplicationInfo, hostInfo:hostInfo})}
                                />
                            </div>
                        </dd>
                    </dl>
                </div>
                <div className="nv_table_box adminVersion" style={{minHeight:'0'}}>
                    <VisitorInfoComponent
                        visitorInfos={visitorInfos}
                        setVisitorInfos={setVisitorInfos}
                        componentType={1}
                        certificateFlag={ certificateFlag }
                    />
                </div>
                <div className="nv_table_box">
                    <div className="btn_area nv_page_bottomarea">
                        <button type="button" id="visitorInfoSave" className="nv_blue_button m_full_btn" onClick={submit}>입력 완료</button>
                    </div>
                </div>   
            </div>
        </>
    )
}

